import { useEffect, useRef } from 'react';

function isMobileApp(): boolean {
  return window.SenseConstants?.isMobileAppRequest ?? false;
}

export function useFontBoostSize<T extends HTMLElement | SVGElement>(
  widthMultiplier?: number,
  heightMultiplier?: number
) {
  const ref = useRef<T>(null);

  useEffect(() => {
    if (widthMultiplier === undefined && heightMultiplier === undefined) {
      return;
    }
    if (!isMobileApp()) return;

    const el = ref.current;
    if (!el) return;

    const sync = () => {
      const fontSize = parseFloat(getComputedStyle(el).fontSize);
      if (Number.isNaN(fontSize)) {
        return;
      }

      if (widthMultiplier !== undefined) {
        el.style.width = `${fontSize * widthMultiplier}px`;
      }
      if (heightMultiplier !== undefined) {
        el.style.height = `${fontSize * heightMultiplier}px`;
      }
    };

    sync();

    const ro = new ResizeObserver(sync);
    ro.observe(document.documentElement);
    window.addEventListener('resize', sync);
    window.addEventListener('orientationchange', sync);

    return () => {
      ro.disconnect();
      window.removeEventListener('resize', sync);
      window.removeEventListener('orientationchange', sync);
    };
  }, [widthMultiplier, heightMultiplier]);

  return ref;
}
